import React, {
  useState,
  useEffect,
} from 'react';

import {
  Popup,
} from 'web-components';

import {
  Flex,
  SVG,
} from 'web-styled';

import * as S from './styled';

type Item = {
  id: number,
  name: string,
};

interface Props {
  activeId: number,
  units: Item[],
  onChange?: { (unit: Item): void },
}

const Units = ({
  units,
  activeId,
  onChange,
}: Props) => {
  if (!units || units?.length < 2) return null;
  const [isOpen, setIsOpen] = useState(true);
  useEffect(() => {
    const id = setTimeout(() => {
      if (units.length > 0) {
        setIsOpen(true);
      }
    }, 10);
    return () => {
      clearTimeout(id);
    };
  }, [units[0]?.id]);

  return (
    <Popup
      isOpen={isOpen}
      trigger={(
        <Flex
          flex="0 0 16px"
          justify="flex-end"
          clickable
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width={14}
            height={14}
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="primary-color"
          >
            <path d="M11 10.27 7 3.34" />
            <path d="m11 13.73-4 6.93" />
            <path d="M12 22v-2" />
            <path d="M12 2v2" />
            <path d="M14 12h8" />
            <path d="m17 20.66-1-1.73" />
            <path d="m17 3.34-1 1.73" />
            <path d="M2 12h2" />
            <path d="m20.66 17-1.73-1" />
            <path d="m20.66 7-1.73 1" />
            <path d="m3.34 17 1.73-1" />
            <path d="m3.34 7 1.73 1" />
            <circle cx="12" cy="12" r="2" />
            <circle cx="12" cy="12" r="8" />
          </svg>
        </Flex>
      )}
      positions={['top']}
      setPopupVisible={() => setIsOpen(!isOpen)}
      onClickOutside={() => setIsOpen(false)}
    >
      <S.Units>
        {units.map(unit => (
          <S.Item
            key={unit.id}
            onClick={() => {
              onChange?.(unit);
              setIsOpen(false);
            }}
          >
            {unit.id === activeId ? (
              <SVG.SquareCheck size={14} />
            ) : (
              <SVG.Square size={14} />
            )}
            {unit.name}
          </S.Item>
        ))}
      </S.Units>
    </Popup>
  );
};

export default Units;
